import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';

export class SettingsHeader extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      w: w => w,
      h: 110,
      color: Theme.Colors.Transparent,
      unfocusable: true,
      Label: {
        x: 0,
        y: 50,
        w: w => w,
        h: h => h,
        text: {
          ...Theme.Fonts.Settings.Header,
          advancedRenderer: true,
          textColor: Theme.Colors.Settings.Header,
          maxLines: 1,
        },
      },
    };
  }

  /**
   * @param {SettingsHeaderData} data
   */
  set data(data) {
    this._data = data;
    this.tag('Label').text.text = data.title;
  }

  get data() {
    return this._data;
  }

  get label() {
    return this._data.title;
  }
}
